import React from "react";
import { useDispatch, useSelector } from "react-redux";
import HelpIcon from "../../../Common/HelpIcon";
import { Spell } from "../../../../lib/types";
import { learnSpell, upgradeSpell } from "../../../../store/actions";
import AlertIcon from "../../../Common/AlertIcon";
import { DragescentState } from "../../../../store/reducers/stateType";

interface IProps {
  govId?: number;
  spell: Spell;
  learnt: boolean;
  available: boolean;
  upgradeable: boolean;
  isPlanned: boolean;
}

const SpellPerson = ({
  govId,
  spell,
  learnt,
  available,
  upgradeable,
  isPlanned,
}: IProps) => {
  const dispatch = useDispatch();
  const id = useSelector((state: DragescentState) => state.governorate.id);

  return (
    <div className="person match-height" style={{ minHeight: "230px" }}>
      <i className={`icon icon-xxlg icon-standalone icon-${spell.buff
        ? "kouzlo-poz"
        : (spell.debuff ? "kouzlo-neg" : "magicke-jadro")} middle grey`}/>
      <p className="text-center">
        <div>{spell.buff ? "Buff" : spell.debuff ? "Debuff" : "Damage"}</div>
        <div style={{ height: "40px", paddingTop: "5px" }}><h3 className={"h3"}>{spell.name}</h3></div>
        <div style={{ paddingTop: "5px" }}>
          <HelpIcon
            title={spell.name}
            content={`<p>${spell.description}</p>
          ${spell.family === 3 && !available ? "<p>Requires:<br />Magic Palace</p>" : ""}
          <p>
            <strong>${spell.price}</strong> <i class="icon icon-sm align-sub icon-mana" />
          </p>`}
            classes={["rich-tooltip", "text-center"]}
            iconClasses={["white"]}
          />
        </div>
        {learnt ? <div style={{ paddingTop: "5px" }}>Level: {spell.level}</div> : <></>}
      </p>
      {!learnt
        ? <a
          className={`btn btn-sm btn-blank ${available ? "" : "disabled"}`}
          style={{
            padding: "2px 5px",
            position: "absolute",
            left: "20%",
            bottom: "30px"
          }}
          onClick={() => available && dispatch(learnSpell(spell.id, govId, !govId || govId === id))}
        >
          Learn
        </a>
        : upgradeable
          ? !isPlanned
            ? <>
              <a
                className={`btn btn-sm btn-blank ${isPlanned ? "disabled" : ""}`}
                style={{
                  padding: "2px 5px",
                  position: "absolute",
                  left: "20%",
                  bottom: "30px"
                }}
                onClick={() => !isPlanned && dispatch(
                  upgradeSpell(spell.family, govId, !govId || govId === id)
                )}
              >
                UP
              </a>
            </>
            : <AlertIcon
              title={"Spell planned"}
              content={"The spell is planned for the count. If you want to upgrade the spell, cancel planned magic."}
            />
          : <></>}
    </div>
  )
};

export default SpellPerson;
